var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.voteRank && _vm.voteRank != 'N/A')?_c('v-chip',{staticClass:"mr-3",staticStyle:{"text-transform":"capitalize","height":"36px","font-weight":"400"},attrs:{"color":_vm.voteRankColor,"label":""}},[_vm._v(" Vote Rank: "+_vm._s(_vm.voteRank)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }